import { useHasPermission } from './permissionUtils';

// True when the user should be locked out of mutating this entity because
// the entity (or its parent) is inactive and the user lacks `canSeeManagement`.
//
// Pass `null` for parent when there is no hierarchy parent (e.g. a client).
export const useIsLocked = (entity, parent) => {
    const hasPermission = useHasPermission();
    const canSeeManagement = hasPermission('canSeeManagement');
    if (canSeeManagement) return false;
    const entityInactive = entity?.active === false;
    const parentInactive = parent?.active === false;
    return entityInactive || parentInactive;
};

// A deleted project is locked for everyone, including canSeeManagement holders, who are the only
// people who can reach one in the first place.
export const useIsProjectLocked = (project) => {
    const inactiveLocked = useIsLocked(project?.account, project?.account?.client);
    return inactiveLocked || !!project?.isDeleted;
};
